import React, { Component } from "react";

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

class SegmentDiff extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		//console.log(this.props.operations);
		let content=[];
		let i=0;
		let currOperation={};
		let prevOperation=null;
		let text="";
		let deleted="";
		let clase="";
		if(typeof(this.props.operations)!=='undefined'){
			while(i<this.props.operations.length){
				currOperation=this.props.operations[i];
				if( prevOperation==null || prevOperation.operation===currOperation.operation){				
					text += currOperation.value;
					if(currOperation.operation=="DELETE" || currOperation.operation=="REPLACE"){
						deleted += currOperation.src;
					}
					//console.log(text);
				}else{
					//console.log("<span>"+{text}+"</span>");
					if(prevOperation.operation=="DELETE" || prevOperation.operation=="REPLACE" && (currOperation.operation!="DELETE" || currOperation.operation!="REPLACE")){
						content.push(<span class="diff_DELETE">{deleted}</span>);
						deleted = "";
					}
					content.push(<span class={clase}>{text}</span>);
					text=currOperation.value;
					if(currOperation.operation=="DELETE" || currOperation.operation=="REPLACE"){
						deleted += currOperation.src;
					}
				}
				i++;
				prevOperation=currOperation;
				clase="diff_"+prevOperation.operation;
			}
			if(currOperation.operation=="DELETE" || currOperation.operation=="REPLACE"){
				content.push(<span class="diff_DELETE">{deleted}</span>);
			}
			content.push(<span class={clase}>{text}</span>);
		}
		//console.log(content);
		return (
			<Box class="tmxSearch">{content}</Box>
		);
	}
}

export default SegmentDiff;